import type { ReactElement } from 'react';

import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import { useComponentContext } from 'hb-builder/hooks';
import type { BuilderComponent } from 'hb-builder/types';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { PartnersItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/partnersItemAttributes';
import Grid, { Row } from 'hb-react/shared/components/DesignSystem/Grid';

const PartnersGrid: BuilderComponent<PartnersItemAttributes> = () => <div />; // never used

const PartnersGridUI = ({
  attributes,
  children,
}: {
  attributes?: PartnersItemAttributes;
  children: ReactElement;
}) => (
  <Grid columnsInMobile p={attributes?.containerPadding} mx={0} width="100%">
    <Row justifyCenter>{children}</Row>
  </Grid>
);

const RenderBuilder = ({ children }) => {
  const { item } = useComponentContext();

  return <PartnersGrid.Render item={item}>{children}</PartnersGrid.Render>;
};
const Render = ({
  children,
  item,
}: RenderProps<DocumentItem<PartnersItemAttributes>>) => (
  <PartnersGridUI attributes={item?.attributes}>{children}</PartnersGridUI>
);

PartnersGrid.componentName = 'PartnersGrid';
PartnersGrid.componentType = 'single';

PartnersGrid.canBeDoubleClicked = false;
PartnersGrid.canBeDragged = false;
PartnersGrid.canBeListed = false;
PartnersGrid.canBeSelected = false;

PartnersGrid.RenderBuilder = RenderBuilder;
PartnersGrid.Render = Render;

PartnersGrid.item = ({ attributes, children }) => ({
  attributes,
  children,
  type: PartnersGrid.componentName,
});

export default PartnersGrid;
